import { useQuery } from '@apollo/client'
import { useContext } from 'react'

import { ProductBySkuWithLabelStatusDocument } from '../../../graphql/search'
import { useLabelName } from '../../../hooks/useLabelName'
import { TokenContext } from '../../../layouts/context'

/**
 * Determines if a product is eligible for reorder based on its label status.
 * Only applies if the product label status feature flag is enabled and the user has a label name.
 */
export function useOrderItemReorderIneligibility(sku: string): boolean {
  const token = useContext(TokenContext)
  const labelName = useLabelName()
  const { data: labelStatusData, loading: labelStatusLoading } = useQuery(
    ProductBySkuWithLabelStatusDocument,
    {
      context: {
        token,
        uri: process.env.GATSBY_SEARCH_URL,
      },
      skip: !token || labelName._tag !== 'Success',
      variables: {
        sku,
        // avoid fetching label status if feature not enabled or label name not available
        labelName: labelName._tag === 'Success' ? labelName.labelName : '',
      },
    },
  )

  return labelStatusData?.productBySku?.labelStatus === 'ABSENT' || labelStatusLoading
}
